import { Component, Injector } from '@angular/core';
import { ThemeService } from 'src/app/services/theme.service';
import { AppFormComponent } from 'src/app/components/tuain/forms/app-form.component';

const frm = {
  name: 'userDetail',
  states: { EDIT: 'EDIT' },
  sections: { editUserSection: 'editUserSection' },
  subsections: { generalInformationSubsection: 'generalInformationSubsection' },
  fields: {
    userId: 'userId',
    userAvatar: 'userAvatar',
    fileContent: 'fileContent',
    uploadAvatar: 'uploadAvatar',
    userName: 'userName',
    userLastName: 'userLastName',
    userEmail: 'userEmail',
    userCellPhone: 'userCellPhone',
    identificationType: 'identificationType',
    userDocumentNumber: 'userDocumentNumber',
    userPhone: 'userPhone',
    userBirthdate: 'userBirthdate',
    userCountry: 'userCountry',
    residenceCity: 'residenceCity',
    userAddress: 'userAddress',
    userPostalCode: 'userPostalCode',
    userDescription: 'userDescription',
  },
  actions: {
    uploadAvatar: 'uploadAvatar',
    saveGeneralInformation: 'saveGeneralInformation',
    saveUser: 'saveUser',
  },
};
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent extends AppFormComponent {
  userName: any;

  constructor(private themeService: ThemeService, private injector: Injector) {
    super(injector);
  }

  override customPreProcessing() { this.formCode = frm.name; }

  override customFormStart() {
    this.userName = `${this.getFieldValue(frm.fields.userName)} ${this.getFieldValue(
      frm.fields.userLastName,
    )}`;
    // const userInfo = JSON.parse(localStorage.getItem('user'));
    const data = {
      userName: this.getFieldValue(frm.fields.userName),
      userLastName: this.getFieldValue(frm.fields.userLastName),
      email: this.getFieldValue(frm.fields.userEmail),
      phone: this.getFieldValue(frm.fields.userCellPhone)?.[1],
      avatar: this.getFieldValue(frm.fields.userAvatar),
    };
    this._eventEmiter.next('profileObtained', data);
  }

  referralsClick() {
    // this._formOperationService.openForm(null, { name: item.form });
  }

  toggleTheme(): void {
    this.themeService.toggleTheme().then();
  }
}
